import React from "react";
import {
  Avatar,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { GroupMember, GroupRole } from "../../lib/types";
import MemberRoleSelector from "./MemberRoleSelector";

interface MembersListProps {
  members: GroupMember[];
  onRoleChange: (member: GroupMember, role: GroupRole) => void;
  onRemove: (member: GroupMember) => void;
}

const MembersList: React.FC<MembersListProps> = ({
  members,
  onRoleChange,
  onRemove,
}) => {
  if (!members.length) {
    return (
      <Stack alignItems="center" spacing={1} sx={{ py: 4 }}>
        <Typography variant="subtitle1">No members yet</Typography>
        <Typography color="text.secondary">
          Invite someone to collaborate.
        </Typography>
      </Stack>
    );
  }

  return (
    <List>
      {members.map((member) => (
        <ListItem
          key={member.id}
          secondaryAction={
            <Stack direction="row" spacing={1} alignItems="center">
              <MemberRoleSelector
                value={member.role}
                onChange={(role) => onRoleChange(member, role)}
                disabled={member.role === "owner"}
              />
              <Tooltip title="Remove member">
                <span>
                  <IconButton
                    edge="end"
                    aria-label="remove member"
                    onClick={() => {
                      console.log("Opening remove member confirm", {
                        memberId: member.userId,
                      });
                      onRemove(member);
                    }}
                    disabled={member.role === "owner"}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </span>
              </Tooltip>
            </Stack>
          }
        >
          <ListItemAvatar>
            <Avatar>
              {(member.displayName || member.email || member.userId || "?")
                .charAt(0)
                .toUpperCase()}
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={member.displayName || member.email || member.userId}
          />
        </ListItem>
      ))}
    </List>
  );
};

export default MembersList;
